import { connect, Provider } from 'react-redux';
export { connect, useDispatch, useSelector } from 'react-redux';
import { createStore, applyMiddleware, combineReducers } from 'redux';
export { combineReducers } from 'redux';
import { PersistGate } from 'redux-persist/integration/react';
import { reducer as reducer$3 } from 'ts-action';
import * as actions from 'ts-action';
export { actions };
import { useLocalStorage, DistanceUnit } from '@grandvision/utils';
export { DistanceUnit } from '@grandvision/utils';
import React__default, { useCallback, createContext, useEffect, createElement, useContext, Component } from 'react';
import { persistReducer as persistReducer$1, persistStore } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';
export { default as sessionStorage } from 'redux-persist/lib/storage/session';
import { format } from 'date-fns';
import ReactHtmlParser from 'react-html-parser';
import { createSelector } from 'reselect';
import { composeWithDevTools } from 'redux-devtools-extension';
import { composeWithDevTools as composeWithDevTools$1 } from 'redux-devtools-extension/logOnly';
import createSagaMiddleware, { END } from 'redux-saga';

var g = typeof window === 'undefined' ? global : window;
function singletonMap(name) {
    var key = "__gv_singleton_maps-" + name;
    if (key in g) {
        return g[key];
    }
    return (g[key] = {});
}

var sagasMap = singletonMap('sagas');
var listener;
var SagaRegistry = {
    register: function (name, saga) {
        if (name in sagasMap) {
            console.warn("Saga with name '" + name + "' is already registered");
            return;
        }
        sagasMap[name] = saga;
        if (listener) {
            listener(saga);
        }
    },
    set listener(l) {
        listener = l;
    },
    get sagas() {
        return Object.values(sagasMap);
    },
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var reducersMap = singletonMap('reducers');
var listener$1;
var ReducersRegistry = {
    get reducers() {
        return __assign({}, reducersMap);
    },
    set listener(l) {
        listener$1 = l;
    },
    register: function (name, reducer) {
        reducersMap[name] = reducer;
        if (listener$1) {
            listener$1(__assign({}, reducersMap));
        }
    },
};

var DEFAULT_LIMIT = 20;
/**
 * Creates a history array in the local storage with some helpers attached.
 *
 * @param key - used as key in the local storage
 * @param limit - limit of items stored in the history array
 *
 * @example usage
 *  import { useViewHistory } from '@grandvision/state'
 *  export const useProductViewHistory = useViewHistory.bind(null, ViewHistoryKey.Products, 30)
 */
function useViewHistory(key, limit) {
    if (limit === void 0) { limit = DEFAULT_LIMIT; }
    var _a = __read(useLocalStorage(key, undefined), 2), history = _a[0], setHistory = _a[1];
    /**
     * Checks if an id exists in the current history
     */
    var has = useCallback(function (id) { var _a; return Boolean(history && ((_a = history.find(function (i) { return i === id; })) === null || _a === void 0 ? void 0 : _a.length)); }, [history]);
    /**
     * Adds one ID to the history array.
     * Duplicated IDs are not allowed.
     * New items are always added at the start of the history.
     * If the limit is exceeded, the last item(s) of the array are cut off.
     */
    var add = useCallback(function (id) {
        setHistory(function (state) {
            if (state === void 0) { state = []; }
            var _a;
            var hasId = Boolean((_a = state.find(function (i) { return i === id; })) === null || _a === void 0 ? void 0 : _a.length);
            var filtered = hasId ? __spread(state.filter(function (i) { return i !== id; })) : __spread(state);
            return __spread([id], filtered).slice(0, limit);
        });
    }, [limit]);
    /**
     * Removes one or more items from the history
     */
    var remove = useCallback(function (ids) {
        setHistory(function (state) {
            if (state === void 0) { state = []; }
            var filters = Array.isArray(ids) ? ids : [ids];
            return filters.reduce(function (result, next) { return __spread(result.filter(function (i) { return i !== next; })); }, __spread(state));
        });
    }, []);
    /**
     * Clears the entire history array by restoring the initial value
     */
    var clear = useCallback(function () {
        setHistory([]);
    }, []);
    return { history: history, has: has, add: add, remove: remove, clear: clear };
}

var persistReducer = function (config, reducer) {
    if (typeof window !== 'undefined' && window.document) {
        return persistReducer$1(config, reducer);
    }
    return reducer;
};

var INIT = 'api-config/INIT';
var init = function (payload) { return ({
    type: INIT,
    payload: payload,
}); };

function reducer (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case INIT:
            return __assign(__assign({}, state), action.payload);
        default:
            return state;
    }
}

var getApiConfig = function (state) {
    return state.apiConfig;
};

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getApiConfig: getApiConfig
});

var createApiConfig = function (config) { return ({
    apiUrl: config.apiUrl,
    apiKey: config.apiKey,
    cartsUrl: config.cartsUrl || config.apiUrl + "/carts",
    locationsUrl: config.locationsUrl || config.apiUrl + "/locations",
    ordersUrl: config.ordersUrl || config.apiUrl + "/orders",
    paymentsUrl: config.paymentsUrl || config.apiUrl + "/payments",
    productsUrl: config.productsUrl || config.apiUrl + "/products",
    storesUrl: config.storesUrl || config.apiUrl + "/stores",
}); };

var ApiConfigContext = createContext(null);
function assertApiConfig(apiConfig) {
    if (apiConfig === null || apiConfig === undefined) {
        throw new Error('Missing API config provider. You have to wrap the application with the ApiConfigProvider component from the @grandvision/state package.');
    }
}
var ApiConfigProvider = function (props) {
    useEffect(function () {
        props.init(createApiConfig(props.apiConfig));
    }, [JSON.stringify(props.apiConfig)]);
    return (createElement(ApiConfigContext.Provider, { value: createApiConfig(props.apiConfig) }, props.children));
};
function withApiConfig(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var WithApiConfig = function (props) { return (createElement(ApiConfigContext.Consumer, null, function (apiConfig) {
        assertApiConfig(apiConfig);
        return createElement(Component, __assign({}, props, { apiConfig: apiConfig }));
    })); };
    WithApiConfig.displayName = "WithApiConfig(" + wrappedName + ")";
    return WithApiConfig;
}
function useApiConfig() {
    var context = useContext(ApiConfigContext);
    if (context === null) {
        throw new Error('Missing API config provider. You have to wrap the application with the ApiConfigProvider component from the @grandvision/state package.');
    }
    return context;
}
var mapDispatchToProps = {
    init: init,
};
var ApiConfig = connect(null, mapDispatchToProps)(ApiConfigProvider);

ReducersRegistry.register('apiConfig', reducer);

var FeatureToggleContext = React__default.createContext({});
var useFeatureToggles = function () { return React__default.useContext(FeatureToggleContext); };
var FeatureToggleProvider = function (_a) {
    var children = _a.children, enabledFeatures = _a.enabledFeatures;
    if (!enabledFeatures) {
        console.error('Unabled to read feature toggles: missing provider.');
        return null;
    }
    var value = React__default.useMemo(function () {
        var isFeatureEnabled = function (feature) {
            return enabledFeatures.includes(feature.toUpperCase());
        };
        return {
            isAABEnabled: isFeatureEnabled('AAB'),
            isABTestingEnabled: isFeatureEnabled('ABTESTING'),
            isAddressBookEnabled: isFeatureEnabled('ADDRESSBOOK'),
            isCartV2Enabled: isFeatureEnabled('CART_V2'),
            isContactLensEnabled: isFeatureEnabled('CONTACTLENS'),
            isContactLensStockEnabled: isFeatureEnabled('CONTACTLENS_STOCK'),
            isCrossSellEnabled: isFeatureEnabled('CROSS_SELL'),
            isGpsStoresEnabled: isFeatureEnabled('GPS_STORES'),
            isMultiCountryLocationsEnabled: isFeatureEnabled('MULTI_COUNTRY_LOCATIONS'),
            isMultilingualEnabled: isFeatureEnabled('MULTILINGUAL'),
            isMyAccountEnabled: isFeatureEnabled('MYACCOUNT'),
            isPreferredContactMethodEnabled: isFeatureEnabled('PREFERRED_CONTACT_METHOD'),
            isPrescriptionGlassesEnabled: isFeatureEnabled('PRESCRIPTION_GLASSES'),
            isPrescriptionGlassesReorderEnabled: isFeatureEnabled('PRESCRIPTION_GLASSES_REORDER'),
            isPrescriptionGlassesConfiguratorValidationStepEnabled: isFeatureEnabled('PRESCRIPTION_GLASSES_CONFIGURATOR_VALIDATION_STEP'),
            isPrescriptionFileEnabled: isFeatureEnabled('PRESCRIPTION_FILE'),
            isReviewsEnabled: isFeatureEnabled('REVIEWS'),
            isSearchEnabled: isFeatureEnabled('SEARCH'),
            isStoreSearchEnabled: isFeatureEnabled('STORE_SEARCH'),
            isStoresPlacePredictionsEnabled: isFeatureEnabled('STORES_PLACE_PREDICTIONS'),
            isSubscriptionHasOneAddressEnabled: isFeatureEnabled('SUBSCRIPTION_HAS_ONE_ADDRESS'),
            isSubscriptionUpdateAddressEnabled: isFeatureEnabled('SUBSCRIPTION_UPDATE_ADDRESS'),
            isVtoEnabled: isFeatureEnabled('VTO'),
        };
    }, [enabledFeatures]);
    return (React__default.createElement(FeatureToggleContext.Provider, { value: value }, children));
};

var Locales;
(function (Locales) {
    Locales["en-IO"] = "en-IO";
    Locales["ca-ES"] = "ca-ES";
    Locales["da-DK"] = "da-DK";
    Locales["en-GB"] = "en-GB";
    Locales["es-ES"] = "es-ES";
    Locales["fr-BE"] = "fr-BE";
    Locales["it-IT"] = "it-IT";
    Locales["nl-BE"] = "nl-BE";
    Locales["nl-NL"] = "nl-NL";
    Locales["pt-PT"] = "pt-PT";
    Locales["sv-SE"] = "sv-SE";
    Locales["en-IE"] = "en-IE";
})(Locales || (Locales = {}));
var Countries;
(function (Countries) {
    Countries["BE"] = "BE";
    Countries["DK"] = "DK";
    Countries["ES"] = "ES";
    Countries["GB"] = "GB";
    Countries["IO"] = "IO";
    Countries["IT"] = "IT";
    Countries["NL"] = "NL";
    Countries["PT"] = "PT";
    Countries["SE"] = "SE";
    Countries["IE"] = "IE";
})(Countries || (Countries = {}));
var Languages;
(function (Languages) {
    Languages["ca"] = "ca";
    Languages["da"] = "da";
    Languages["en"] = "en";
    Languages["es"] = "es";
    Languages["fr"] = "fr";
    Languages["it"] = "it";
    Languages["nl"] = "nl";
    Languages["pt"] = "pt";
    Languages["sv"] = "sv";
})(Languages || (Languages = {}));
var Currencies;
(function (Currencies) {
    Currencies["EUR"] = "EUR";
    Currencies["GBP"] = "GBP";
    Currencies["USD"] = "USD";
    Currencies["SEK"] = "SEK";
    Currencies["DKK"] = "DKK";
})(Currencies || (Currencies = {}));
var IntlContext = React__default.createContext({});
var useIntl = function () { return useContext(IntlContext); };
function withIntl(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var WithIntl = function (props) { return (React__default.createElement(IntlContext.Consumer, null, function (context) { return React__default.createElement(Component, __assign({}, props, { intl: context })); })); };
    WithIntl.displayName = "WithIntl(" + wrappedName + ")";
    return WithIntl;
}

var INIT$1 = 'intl/INIT';
var init$1 = function (payload) { return ({
    type: INIT$1,
    payload: payload,
}); };

/**
 * Mapping to dynamically import the date-fns Locale object for your locale.
 * You can extend this map if you need a locale that's currently not in there if it's supported by date-fns.
 * https://date-fns.org/v2.0.0-beta.2/docs/I18n#supported-languages
 */
var dateFnsLocaleMap = {
    en: function () { return import('date-fns/locale/en-GB'); },
    'en-GB': function () { return import('date-fns/locale/en-GB'); },
    'en-US': function () { return import('date-fns/locale/en-US'); },
    it: function () { return import('date-fns/locale/it'); },
    nl: function () { return import('date-fns/locale/nl'); },
    pt: function () { return import('date-fns/locale/pt'); },
    sv: function () { return import('date-fns/locale/sv'); },
    da: function () { return import('date-fns/locale/da'); },
    fr: function () { return import('date-fns/locale/fr'); },
    es: function () { return import('date-fns/locale/es'); },
    ca: function () { return import('date-fns/locale/ca'); },
};
/**
 * Gets the dynamic import for the passed locale.
 * Use this function to get your locale import, don't expose the map directly.
 *
 * @example
 * const dateFnsLocaleModule = getDateFnsLocaleModule('it-IT')
 * const { default: dateFnsLocale } = await dateFnsLocaleModule()
 */
function getDateFnsLocaleModule(locale) {
    if (dateFnsLocaleMap[locale]) {
        return dateFnsLocaleMap[locale]();
    }
    // If we can't find an obj for the more specific locale (en-GB),
    // Try to find a less specific one for the language code only (en).
    var language = locale.substr(0, 2);
    if (dateFnsLocaleMap[language]) {
        return dateFnsLocaleMap[language]();
    }
    return undefined;
}

var handleFormatDate = function (dateFormats, value, dateFormatKey, options) {
    return format(value, dateFormats[dateFormatKey], options);
};
var handleLongDate = function (dateFormat, date, options) { return handleFormatDate(dateFormat, date, 'long', options); };
var handleMidsizeDate = function (dateFormat, date, options) { return handleFormatDate(dateFormat, date, 'midsize', options); };
var handleShortDate = function (dateFormat, date, options) { return handleFormatDate(dateFormat, date, 'short', options); };
var handleFormatTime = function (timeFormats, value, timeFormatKey, options) {
    return format(value, timeFormats[timeFormatKey || 'default'], options);
};

/**
 * Merges labels as received from the call to Bloomreach into a flat 1 level deep object,
 * and prefixes each label key with the key of the parent object (e.g. carts or stores)
 */
var mergeLabels = function (labels) {
    return Object.keys(labels).reduce(function (merged, key) { return (__assign(__assign({}, merged), Object.entries(labels[key]).reduce(function (innerLabels, _a) {
        var _b;
        var _c = __read(_a, 2), labelKey = _c[0], label = _c[1];
        return (__assign(__assign({}, innerLabels), (_b = {}, _b[key + "." + labelKey] = label, _b)));
    }, {}))); }, {});
};
var hasLabel = function (labels, key) { return !!labels[key]; };
var isDebugEnabled = (function () {
    try {
        return !!localStorage.getItem('gv:debug:intl');
    }
    catch (error) {
        return false;
    }
})();
var getLabel = function (labels, key, optionsConfig) {
    if (optionsConfig === void 0) { optionsConfig = {}; }
    var defaultValue = optionsConfig.defaultValue, _a = optionsConfig.hideLabelKey, hideLabelKey = _a === void 0 ? false : _a;
    if (isDebugEnabled) {
        return "[" + key + "]";
    }
    return labels[key] || defaultValue || (hideLabelKey ? '' : "[" + key + "]");
};
var getFormattedLabel = function (labels, key, optionsConfig) {
    if (optionsConfig === void 0) { optionsConfig = {}; }
    var parseLinkEnabled = optionsConfig.parseLink, parseHTML = optionsConfig.parseHTML, labelData = optionsConfig.labelData, openLinksInNewTab = optionsConfig.openLinksInNewTab, getLabelOptions = __rest(optionsConfig, ["parseLink", "parseHTML", "labelData", "openLinksInNewTab"]);
    var label = getLabel(labels, key, getLabelOptions);
    if (isDebugEnabled) {
        return label;
    }
    if (labelData) {
        label = replaceVars(label, labelData);
    }
    if (parseLinkEnabled) {
        label = parseLink(label, openLinksInNewTab);
    }
    /*
      by default parses if parseLinkEnabled,
      unless parseHTML explicitly set to false
    */
    if (parseHTML || (parseLinkEnabled && parseHTML !== false)) {
        label = ReactHtmlParser(label);
    }
    return label;
};
var replaceVars = function (label, data) {
    Object.keys(data).forEach(function (key) {
        label = label.replace("{" + key + "}", data[key].toString());
    });
    return label;
};
// Parses MarkDown style links to HTML string
// [I'm an inline-style link with title](https://www.google.com "Google's Homepage")
var parseLink = function (label, openInNewTab) {
    if (openInNewTab === void 0) { openInNewTab = false; }
    var regex = /[\[]{1}([^\]\[]+)[\]]{1}[(]{1}([^()"]+)("(.+)")?[)]{1}/g;
    return label.replace(regex, openInNewTab
        ? '<a href="$2" title="$4" target="_blank" rel="noopener">$1</a>'
        : '<a href="$2" title="$4">$1</a>');
};

var settingsDefaults = {
    distanceUnit: DistanceUnit.km,
    dateFormat: {
        long: 'EEEE do MMMM, yyyy',
        midsize: 'dd MMMM yyyy',
        short: 'dd/MM/yyyy',
    },
    timeFormat: {
        default: 'H:mm',
    },
};
var mergeSettings = function (props) { return (__assign(__assign({}, settingsDefaults), props.settings)); };
var supportedLocales = Object.keys(Locales);
var supportedCurrencies = Object.keys(Currencies);
var supportedDistanceUnits = Object.keys(DistanceUnit);
var IntlProvider = /** @class */ (function (_super) {
    __extends(IntlProvider, _super);
    function IntlProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { context: _this.createContext(_this.props) };
        _this.onLocaleLoaded = function (dateFnsLocaleModule) {
            if (dateFnsLocaleModule && 'default' in dateFnsLocaleModule) {
                _this.setState(function (prevState) { return ({
                    context: __assign(__assign({}, prevState.context), { dateFnsLocale: dateFnsLocaleModule.default }),
                }); });
            }
        };
        var _a = mergeSettings(props), country = _a.country, currency = _a.currency, distanceUnit = _a.distanceUnit, dateFormat = _a.dateFormat, timeFormat = _a.timeFormat, language = _a.language;
        _this.props.init({ country: country, currency: currency, distanceUnit: distanceUnit, dateFormat: dateFormat, timeFormat: timeFormat, language: language });
        var locale = language + "-" + country;
        var dateFnsLocaleModule = getDateFnsLocaleModule(locale);
        if (dateFnsLocaleModule) {
            dateFnsLocaleModule.then(_this.onLocaleLoaded);
        }
        else {
            console.warn("Could not find a date-fns locale obj for locale: " + locale);
        }
        return _this;
    }
    IntlProvider.prototype.componentDidUpdate = function (_a) {
        var prevSettings = _a.settings;
        var settings = this.props.settings;
        var compareSettingKeys = [
            'language',
            'country',
            'currency',
            'distanceUnit',
            'dateFormat',
            'timeFormat',
        ];
        if (compareSettingKeys.some(function (key) { return settings[key] !== prevSettings[key]; })) {
            this.setState({ context: this.createContext(this.props) });
        }
    };
    IntlProvider.prototype.render = function () {
        var children = this.props.children;
        var context = this.state.context;
        return createElement(IntlContext.Provider, { value: context }, children);
    };
    IntlProvider.prototype.createContext = function (props) {
        var _this = this;
        var labels = props.labels;
        var _a = mergeSettings(props), language = _a.language, country = _a.country, currency = _a.currency, distanceUnit = _a.distanceUnit, dateFormat = _a.dateFormat, timeFormat = _a.timeFormat;
        var locale = language + "-" + country;
        if (!(language in Languages)) {
            console.warn("Invalid language \"" + language + "\" set on IntlProvider. Use 2 lowercase characters like \"en\"");
        }
        if (!(country in Countries)) {
            console.warn("Invalid country \"" + country + "\" set on IntlProvider. Use 2 uppercase characters like \"GB\"");
        }
        if (!(locale in Locales)) {
            console.warn("Unsupported locale \"" + locale + "\" set on IntlProvider. Supported locales are: " + supportedLocales.join(', '));
        }
        if (!supportedCurrencies.includes(currency)) {
            console.warn("Unsupported or invalid currency \"" + currency + "\" set on IntlProvider. Supported currencies are: " + supportedCurrencies.join(', '));
        }
        if (!supportedDistanceUnits.includes(distanceUnit)) {
            console.warn("Unsupported or invalid distance unit \"" + distanceUnit + "\" set on IntlProvider. Supported distance units are: " + supportedDistanceUnits.join(', '));
        }
        return {
            country: country,
            currency: currency,
            distanceUnit: distanceUnit,
            language: language,
            locale: locale,
            dateFormat: dateFormat,
            timeFormat: timeFormat,
            dateTime: {
                formatDate: function (dateTime, key) {
                    var dateFnsLocale = _this.state.context.dateFnsLocale;
                    return handleFormatDate(dateFormat, dateTime, key, { locale: dateFnsLocale });
                },
                formatLongDate: function (dateTime) {
                    var dateFnsLocale = _this.state.context.dateFnsLocale;
                    return handleLongDate(dateFormat, dateTime, { locale: dateFnsLocale });
                },
                formatMidsizeDate: function (dateTime) {
                    var dateFnsLocale = _this.state.context.dateFnsLocale;
                    return handleMidsizeDate(dateFormat, dateTime, { locale: dateFnsLocale });
                },
                formatShortDate: function (dateTime) {
                    var dateFnsLocale = _this.state.context.dateFnsLocale;
                    return handleShortDate(dateFormat, dateTime, { locale: dateFnsLocale });
                },
                formatTime: function (dateTime, key) {
                    var dateFnsLocale = _this.state.context.dateFnsLocale;
                    return handleFormatTime(timeFormat, dateTime, key, { locale: dateFnsLocale });
                },
            },
            getLabel: function (key, options) { return getLabel(labels, key, options); },
            getFormattedLabel: function (key, options) { return getFormattedLabel(labels, key, options); },
            hasLabel: function (key) { return hasLabel(labels, key); },
        };
    };
    return IntlProvider;
}(Component));
var mapDispatchToProps$1 = {
    init: init$1,
};
var IntlProvider$1 = connect(null, mapDispatchToProps$1)(IntlProvider);

function reducer$1 (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case INIT$1:
            return __assign(__assign({}, state), action.payload);
        default:
            return state;
    }
}

var getIntl = function (state) { return state.intl; };
var getCurrency = createSelector(getIntl, function (intl) {
    return intl && intl.currency ? intl.currency : undefined;
});
var getLanguage = createSelector(getIntl, function (intl) {
    return intl && intl.language ? intl.language : undefined;
});
var getCountry = createSelector(getIntl, function (intl) {
    return intl && intl.country ? intl.country : undefined;
});
var getLocale = createSelector(getIntl, function (intl) {
    return intl && intl.country && intl.language ? intl.language + "-" + intl.country : undefined;
});
var getDistanceUnit = createSelector(getIntl, function (intl) {
    return intl && intl.distanceUnit ? intl.distanceUnit : undefined;
});

var selectors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getIntl: getIntl,
  getCurrency: getCurrency,
  getLanguage: getLanguage,
  getCountry: getCountry,
  getLocale: getLocale,
  getDistanceUnit: getDistanceUnit
});

ReducersRegistry.register('intl', reducer$1);

/**
 * Statuses
 */
var UNAVAILABLE = 'unavailable';
var IDLE = 'idle';
var UNINIT = 'uninitialized';
var SUCCESS = 'success';
var LOADING = 'loading';
var FAILED = 'failed';
var WARNING = 'warning';
/**
 * State creators
 */
var unavailableState = function () { return ({ status: UNAVAILABLE }); };
var idleState = function () { return ({ status: IDLE }); };
var uninitState = function () { return ({ status: UNINIT }); };
var loadingState = function () { return ({ status: LOADING }); };
var successState = function (result) { return ({
    status: SUCCESS,
    result: result,
}); };
var warningState = function (state, error) {
    return __assign(__assign({}, state), { status: WARNING, error: error });
};
var failedState = function (error) { return ({
    status: FAILED,
    error: error,
}); };
/**
 * State guards
 */
var statusIdle = function (state) {
    return state.status === IDLE;
};
var statusUnavailable = function (state) { return state.status === UNAVAILABLE; };
var statusUninit = function (state) { return state.status === UNINIT; };
var statusLoading = function (state) { return state.status === LOADING; };
var statusSuccess = function (state) { return state.status === SUCCESS; };
var statusWarning = function (state) { return state.status === WARNING; };
var statusFailed = function (state) { return state.status === FAILED; };

var sagaMiddleware = createSagaMiddleware();
var bindMiddleware = function (middleware) {
    return applyMiddleware.apply(void 0, __spread(middleware));
};
var persistConfig = {
    key: 'grandvision_store',
    whitelist: ['checkout', 'cart'],
    storage: sessionStorage,
};
var getRootReducer = function (reducers, isServer) {
    var rootReducer = combineReducers(__assign({}, reducers));
    if (isServer) {
        return rootReducer;
    }
    return persistReducer$1(persistConfig, rootReducer);
};
var initStore = function (initialState, _a) {
    if (initialState === void 0) { initialState = {}; }
    var isServer = _a.isServer;
    var rootReducer = getRootReducer(ReducersRegistry.reducers, isServer);
    var devToolsOptions = {
        serialize: true,
    };
    var devTools = process.env.NODE_ENV !== 'production'
        ? composeWithDevTools(devToolsOptions)
        : composeWithDevTools$1(devToolsOptions);
    var plainStore = createStore(rootReducer, initialState, devTools(bindMiddleware([sagaMiddleware])));
    // Add the redux persistor to the store
    var persistor = persistStore(plainStore);
    var store;
    if (!isServer) {
        store = Object.assign(plainStore, {
            persistor: persistor,
            // Make sure we run the sagas that have been registered before the store is initialized
            runningSagas: SagaRegistry.sagas.map(sagaMiddleware.run),
            close: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            store.dispatch(END);
                            return [4 /*yield*/, Promise.all(store.runningSagas.map(function (t) { return t.toPromise(); }))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
        });
    }
    else {
        store = Object.assign(plainStore, {
            persistor: persistor,
            runningSagas: [],
            close: function () { return Promise.resolve(); },
        });
        SagaRegistry.listener = function (sagas) {
            store.runningSagas.push(sagaMiddleware.run(sagas));
        };
    }
    ReducersRegistry.listener = function (reducers) {
        store.replaceReducer(getRootReducer(reducers, isServer));
    };
    return store;
};

var ViewHistoryKey;
(function (ViewHistoryKey) {
    ViewHistoryKey["Products"] = "view_history.products";
})(ViewHistoryKey || (ViewHistoryKey = {}));

// Re-export within redux namespace
var ReduxProvider = Provider;
var ReduxPersistGate = PersistGate;
var reducer$2 = reducer$3;

export { ApiConfigContext, ApiConfig as ApiConfigProvider, selectors as ApiConfigSelectors, Countries, Currencies, DEFAULT_LIMIT, FAILED, FeatureToggleProvider, IDLE, IntlContext, IntlProvider$1 as IntlProvider, selectors$1 as IntlSelectors, LOADING, Languages, Locales, ReducersRegistry, ReduxPersistGate, ReduxProvider, SUCCESS, SagaRegistry, UNAVAILABLE, UNINIT, ViewHistoryKey, WARNING, assertApiConfig, failedState, idleState, initStore, loadingState, mergeLabels, persistConfig, persistReducer, reducer$2 as reducer, statusFailed, statusIdle, statusLoading, statusSuccess, statusUnavailable, statusUninit, statusWarning, successState, unavailableState, uninitState, useApiConfig, useFeatureToggles, useIntl, useViewHistory, warningState, withApiConfig, withIntl };
//# sourceMappingURL=index.es.js.map
